<template>
  <v-card>
    <v-card-title class="pr-2" :style=" { backgroundColor: companyPrimaryColor }">
      <h2 style="color:white">Gebruiker bewerken</h2>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="closeEditUserDialog()">
        <v-icon dark color="white">close</v-icon>
      </v-btn>
    </v-card-title>

    <v-alert
      class="ma-2 pa-2"
      v-if="feedback"
      :value="true"
      type="warning"
    >
    {{ feedback }} 
    </v-alert>

    <v-divider></v-divider>

    <v-card-text>
      <v-form  ref="EditUserForm" lazy-validation>
        <v-container grid-list-md fluid class="ma-0 pa-0">
          <v-layout row wrap class="ma-0 pa-0">
            <v-flex xs12 v-if="formType == 'superadmin'">
              <v-select
                class="pt-2"
                :items="companies"
                v-model="userFormInfo.company"
                label="Aansluiting"
                hint="Selecteer bij welke aansluiting de gebruiker hoort"
                item-text="name"
                item-value="id"
                prepend-inner-icon="business"
                persistent-hint
                v-on:input="loadBranches(userFormInfo.company)"
                :color="companyPrimaryColor"
                :item-color="companyPrimaryColor"
                background-color="background"       
                hide-details
                outlined
              ></v-select>
            </v-flex>
            
            <v-flex md6 xs12>
              <v-text-field
                class="pt-2"
                label="Voornaam"
                v-model="userFormInfo.firstName"
                autocomplete="disabled"
                prepend-inner-icon="account_box"
                :color="companyPrimaryColor"
                background-color="background"       
                hide-details
                outlined
                required
              ></v-text-field>
            </v-flex>
            <v-flex md6 xs12>
              <v-text-field
                class="pt-2"
                label="Achternaam"
                v-model="userFormInfo.lastName"
                autocomplete="disabled"
                prepend-inner-icon="account_box"
                :color="companyPrimaryColor"
                background-color="background"       
                hide-details
                outlined
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                class="pt-2"
                label="E-mailadres"
                v-model="userFormInfo.email"
                :rules="emailRules"
                autocomplete="disabled"
                prepend-inner-icon="email"
                :color="companyPrimaryColor"
                background-color="background"       
                hide-details
                outlined
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-select
                class="pt-2"
                :items="userRoles"
                v-model="userFormInfo.userRole"
                label="Rol"
                item-text="name"
                item-value="id"
                prepend-inner-icon="verified_user"
                :color="companyPrimaryColor"
                :item-color="companyPrimaryColor"
                background-color="background"       
                hide-details
                outlined
                required
              ></v-select>
              <div v-if="userFormInfo.userRole == 'superadmin'" class="userrole-explaination">
                Een <b>Superadmin</b> beheerd alle gebruikers en aansluitingen.
              </div>
              <div v-if="userFormInfo.userRole == 'admin'" class="userrole-explaination">
                Een <b>Admin</b> heeft alle bevoegdheden.
              </div>
              <div v-if="userFormInfo.userRole == 'manager'" class="userrole-explaination">
                Een <b>Managers</b> heeft de bevoegdheid om gegevens van medewerkers te wijzigen en nieuwe gebruikers aan te maken. Extra gebruikerrechten kunnen per gebruiker worden toegevoegd.
              </div>
              <div v-if="userFormInfo.userRole == 'employee'" class="userrole-explaination">
                Een <b>Medewerker</b> heeft standaard alleen de bevoegdheid om beperkte gegevens te bekijken. Extra gebruikerrechten kunnen per gebruiker worden toegevoegd.
              </div>
            </v-flex>
            
            <v-flex xs12 v-if="userFormInfo.userRole == 'employee' || userFormInfo.userRole == 'manager'">
              <v-select
                class="pt-2"
                v-if="formType == 'superadmin'"
                :items="loadedBranches"
                v-model="userFormInfo.branches"
                label="Vestigingen"
                item-text="branchName"
                hint="Selecteer tot welke locaties de gebruiker toegang heeft"
                item-value="id"
                multiple
                prepend-inner-icon="business"
                persistent-hint
                :color="companyPrimaryColor"
                :item-color="companyPrimaryColor"
                background-color="background"
                no-data-text="Nog geen locaties toegevoegd."             
                hide-details
                outlined
                required
              ></v-select>
              <v-select
                class="pt-2"
                v-if="formType == 'company'"
                :items="branches"
                v-model="userFormInfo.branches"
                label="Vestigingen"
                item-text="branchName"
                hint="Selecteer tot welke locaties de gebruiker toegang heeft"
                item-value="id"
                multiple
                prepend-inner-icon="business"
                persistent-hint
                :color="companyPrimaryColor"
                :item-color="companyPrimaryColor"
                background-color="background"   
                no-data-text="Nog geen locaties toegevoegd."          
                hide-details
                outlined
                required
              ></v-select>
            </v-flex>
            <v-flex>
              <v-switch
                :color="companyPrimaryColor"
                v-model="userFormInfo.active"
                class="pa-0"
                hide-details
                >
                <template slot='label'>
                  <span :style="{color: $vuetify.theme.themes[theme].text}" style="margin-right: 5px;">Actief</span>
                  <v-tooltip class="ma-0 pa-0" right >
                    <template v-slot:activator="{ on }">
                      <v-icon small :color="companyPrimaryColor" v-on="on">help</v-icon>
                    </template>
                    <span class="white--text">Gebruiker kan alleen inloggen als het account actief is.</span>
                  </v-tooltip>
                </template>
              </v-switch>
            </v-flex>
            
          </v-layout>
        </v-container>

      </v-form>
    </v-card-text>

    <v-divider></v-divider>
    
    <v-card-actions>
      <v-container grid-list-md fluid class="ma-0 pa-0">
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex xs12 md6 class="text-left" v-if="$vuetify.breakpoint.name != 'sm' && $vuetify.breakpoint.name != 'xs'">
            <v-btn
              outlined
              depressed
              :color="companySecondaryColor" 
              @click="closeEditUserDialog()"
              >
              Annuleren
            </v-btn>
          </v-flex>
          <v-flex xs12 md6 class="text-right">
            <v-btn
              :disabled=" !changed || busy" 
              :depressed="!changed || busy"  
              :dark=" changed || busy"  
              :block="$vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'xs'"
              rounded 
              :color="companyPrimaryColor" 
              @click="updateUser()"
              >
              Wijzigingen opslaan
              <v-icon right dark>chevron_right</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-actions>
  </v-card>
</template>


<script>
import slugify from "slugify";
import db from "../../firebase/init";
import firebase from "firebase/app";
import platform from 'platform'; 
import { bus } from "../../main";
import _ from "lodash";
import axios from 'axios';


export default {
  name: "edit-user-form",
  props: {
    formType: String,
    showDialog: Boolean,
    companies: Array,
    branches: Array,
    userFormInfo: Object,
    userFormInfoOriginal: Object,
    userRoles: Array
  },
  data() {
    return {
      busy: false,
      showEditDialog: true,
      feedback: null,
      errors: [],
      searchCompanies: "",
      loadedBranches: [],
      emailRules: [
        v => !!v || "E-mail is verplicht",
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || "E-mail must be valid"
      ],
      passwordRules: [v => !!v || "Wachtwoord is verplicht"]
    };
  },

  
  created(){
    bus.$on("getCompanyBranches", company => {
      this.loadBranches(company)
    });
  },

  methods: {
    resetForm() {
      this.$refs.AddUserForm.reset();
    },

    closeEditUserDialog() {
      this.$emit("userEditDialogChange", false);
    },

    loadBranches(company) {
      if(company){
        db.collection("branches")
        .where("compId", "==", company)
        .get()
        .then(snap => {
          this.loadedBranches = [];
          snap.forEach(doc => {
            let branchCollection = doc.data();
            branchCollection.id = doc.id;
            this.loadedBranches.push(branchCollection);
          });
        });
      }
    },

    updateUser() {
      this.busy = true;
      db.collection("users")
        .doc(this.userFormInfo.id)
        .update({
          firstName: this.userFormInfo.firstName,
          lastName: this.userFormInfo.lastName,
          userRole: this.userFormInfo.userRole,
          company: this.userFormInfo.company,
          branches: this.userFormInfo.branches,
          email: this.userFormInfo.email,
          active: this.userFormInfo.active
        })
        .then(() => {
          if(this.userFormInfoOriginal.active && !this.userFormInfo.active){
            var config = {
              method: 'post',
              url: 'https://europe-west1-call-traffic-data.cloudfunctions.net/auth',
              headers: { 
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*'
              },
              data : {
                type: 'disableUser',
                uid: this.userFormInfo.user_id
              }
            };
            axios(config)
          }
          if(!this.userFormInfoOriginal.active && this.userFormInfo.active){
            var config = {
              method: 'post',
              url: 'https://europe-west1-call-traffic-data.cloudfunctions.net/auth',
              headers: { 
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*'
              },
              data : {
                type: 'enableUser',
                uid: this.userFormInfo.user_id
              }
            };
            axios(config)
          }
        })
        .then(() => {
          // Log Action
          db.collection("log").add({
            time: new Date(),
            logType: "info",
            user: this.userFirstName + " " + this.userLastName,
            userType: this.userRole,
            company: this.userCompany,
            actionType: "User Action",
            software: String(platform.os),
            browser: platform.name + " " + platform.version, 
            action: "Gebruiker bewerkt",
            extra:
              "<b>ORIGINELE GEGEVENS</b>" +
              "<br>" +
              "<b>Naam</b>: " +
              this.userFormInfoOriginal.firstName +
              " " +
              this.userFormInfoOriginal.lastName +
              "<br>" +
              "<b>Rol</b>: " +
              this.userFormInfoOriginal.userRole +
              "<br>" +
              "<b>Email</b>: " +
              this.userFormInfoOriginal.email +
              "<br>" +
              "<b>Aansluiting</b>: " +
              this.userFormInfoOriginal.company +
              "<br><br>" +
              "<b>AANGEPASTE GEGEVENS</b>" +
              "<br>" +
              "<b>Naam</b>: " +
              this.userFormInfo.firstName +
              " " +
              this.userFormInfo.lastName +
              "<br>" +
              "<b>Rol</b>: " +
              this.userFormInfo.userRole +
              "<br>" +
              "<b>Email</b>: " +
              this.userFormInfo.email +
              "<br>" +
              "<b>Aansluiting</b>: " +
              this.userFormInfo.company
          });
        })
        .then(()=>{
          this.$emit("updateData");
          this.closeEditUserDialog();
          this.busy = false;
          this.$refs.EditUserForm.reset();
        })
        .catch(error => {
          console.error("Error updating User: ", error);
          this.busy = false;
          db.collection("log").add({
            time: new Date(),
            logType: "error",
            user: this.userFirstName + " " + this.userLastName,
            userType: this.userRole,
            company: this.userCompany,
            actionType: "User Action",
            software: String(platform.os),
            browser: platform.name + " " + platform.version,
            action: "Error updating User: " + this.activeCompName,
            extra: JSON.stringify(error)
          });
        });
    }
  },
  computed: {
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    // userRoles() {
    //   let userRolesSuperadmin = [
    //     { name: "Superadmin", id: "superadmin" },
    //     { name: "Admin", id: "admin" },
    //     { name: "Manager", id: "manager" },
    //     { name: "Medewerker", id: "employee" }
    //   ];
    //   let userRoles = [
    //     { name: "Admin", id: "admin" },
    //     { name: "Manager", id: "manager" },
    //     { name: "Medewerker", id: "employee" }
    //   ];
    //   if (this.formType == "superadmin") {
    //     return userRolesSuperadmin;
    //   } else {
    //     return userRoles;
    //   }
    // },
    companyPackages() {
      return this.$store.state.companyPackages;
    },
    companyType() {
      return this.$store.state.companyType;
    },
    filteredCompanies() {
      if (this.searchCompanies && this.searchCompanies.length > 0) {
        return this.companies.filter(company => {
          return company.name.toLowerCase().includes(this.searchCompanies.toLowerCase());
        });
      } else {
        return this.companies;
      }
    },
    changed() {
      if (_.isEqual(this.userFormInfo, this.userFormInfoOriginal) == false) {
        return true;
      } else {
        return false;
      }
    },
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    }
  }
};
</script>
